import React from 'react';
import { EcoClub8Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub8Class2026/>;
};

export default AccountGeneralPage;